<div class="tabbable__body no-margin">
  <h2>Fakturaverktyg</h2>
  <br>
  <h3>Hämta fakturor i excel format</h3>
  <period-select
    name="period"
    [defaultInitDate]="InitialDate.Current"
    [firstSelectableDate]="firstSelectableDate"
    [ngModel]="period"
    (ngModelChange)="periodChanged($event)"
  ></period-select>
    <button type="submit" class="button primary" [disabled]="!savable()" (click)="downloadInvoiceExcel()">Hämta</button>
</div>
